export const dataHooks = {
  TimeInputInput: 'TimeInput-input',
  TimeInputDropdown: 'TimeInput-dropdown',
};

export const _24hourTimeFormats = [
  'en-GB',
  'bg',
  'ca',
  'zh',
  'cs',
  'da',
  'nl',
  'fi',
  'fr',
  'fr-CA',
  'fr-CH',
  'fr-BE',
  'de',
  'de-CH',
  'de-AT',
  'he',
  'ja',
  'lt',
  'hu',
  'id',
  'it',
  'nb',
  'nn',
  'pl',
  'pt-BR',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'es',
  'es-419',
  'es-AR',
  'es-MX',
  'sv',
  'th',
  'uk',
  'vi',
];

export const _12hourTimeFormats = [
  'en',
  'en-US',
  'en-AU',
  'en-CA',
  'ar',
  'zh-TW',
  'zh-HK',
  'zh-MO',
  'el',
  'hi',
  'ko',
  'ms',
  'es-US',
  'tl',
  'tr',
];
